import React from "react";
import { Link } from "react-router-dom";
import "./styles/AboutPreview.css";
import larry from './../assets/larryInShop.webp';

const AboutPreview = () => {
  return (
    <section className="about-preview" role="complementary" aria-labelledby="about-preview-heading">
      <div className="about-container"> {/* ✅ Wrap text & image */}
        
        {/* ✅ Text Content */}
        <div className="about-content">
          <p>
            Withrow Knives is a family-driven craft, blending tradition and modern expertise to create the best high-quality handmade knives in West Virginia. 
            Every blade is a reflection of our dedication to precision, durability, and artistry. 
            From carefully selecting the finest materials to hand-finishing each knife, we take pride in producing functional works of art. 
            Whether it’s a rugged fixed-blade, a sleek folding knife, or a hand-forged Damascus masterpiece, each piece is designed to stand the test of time.
          </p>

          <div className="read-more">
            <Link to="/about" className="read-more-btn" aria-label="Read more about Withrow Knives">Read More About Us <i className="fa-solid fa-arrow-right"></i></Link>
          </div>
        </div>

        {/* ✅ Image with Caption */}
        <div className="about-image">
          <img src={larry} alt="Larry in the shop" />
          <p className="image-caption" aria-hidden="true">Larry in the workshop demonstrating his process.</p>
        </div>
        
      </div>
    </section>
  );
};

export default AboutPreview;
